import device from 'current-device';
import {CHROME_VENDOR} from "../constants/constants";
import debounce from "lodash/debounce";
import {setCssVar} from "./commonUtility";

// export const isIos = () => {return true};
export const isIos = device.ios;

export const isTablet = device.tablet;

export const isMobile = device.mobile;

export const isDesktop = device.desktop;

export const isAndroidOS = device.android;

//source site: https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser?rq=1

export const isOpera = () => (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
export const isFirefox = () => typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
export const isSafari = () => /constructor/i.test(window.HTMLElement) || (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
})(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

// Internet Explorer 6-11
export const isIE = () => /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
export const isEdge = () => !isIE() && !!window.StyleMedia;

// Chrome 1 - 79
export const isChrome = () => navigator.vendor === CHROME_VENDOR;

// Edge (based on chromium) detection
export const isEdgeChromium = () => isChrome() && (navigator.userAgent.indexOf("Edg") != -1);

// Blink engine detection
export const isBlink = () => (isChrome() || isOpera()) && !!window.CSS;

export const isIpad = device.ipad;

export const isIpadChrome = () => (isIpad() && navigator.userAgent.match('CriOS'));

export const isIosChrome = () => (navigator.userAgent.match('CriOS'));

export const isChromebook = /\bCrOS\b/.test(navigator.userAgent);

export const getDeviceType = () => (device.type);

export const isMobileViewForTablet = () => (isChromebook || isTablet()) && (screen.width < 767 || screen.height < 640);

export const isFB = () => navigator.userAgent.match('FBAN|FBAV|Instagram')

export const setupKeyboardDetection = () => {
    if (!isDesktop() && 'visualViewport' in window) {
        let fullHeight = window.visualViewport.height;
        let width = window.visualViewport.width
        const detectVirtualKeyboard = debounce(() => {
            // this means we just changed orientation
            if (width !== window.visualViewport.width) {
                width = window.visualViewport.width;
                return;
            }
            fullHeight = Math.max(fullHeight, window.visualViewport.height);
            if (window.visualViewport.height / fullHeight <= 0.75) {
                const keyboardSize = fullHeight - window.visualViewport.height;
                setTimeout(() => {
                    window.scrollBy(0, -keyboardSize)
                })
                setCssVar('--keyboard-size', `${keyboardSize}px`);
            } else {
                setCssVar('--keyboard-size', '0px');
            }
        }, 200)
        window.visualViewport.addEventListener('resize', detectVirtualKeyboard);
    } else {
        setCssVar('--keyboard-size', '0px');
    }
}